var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 57,
    width: 225,
    height: 409,
    fill: "#231942"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2952_4230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 13,
    width: 278,
    height: 474
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111 13H388.958V486.12H111V13Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2952_4230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.881 13H164.851C135.158 13 111.07 37.0872 111.07 66.7497V432.371C111.07 462.033 135.158 486.12 164.851 486.12H336.881C366.574 486.12 390.661 462.033 390.661 432.371V66.7497C390.661 37.0872 366.574 13 336.881 13ZM250.85 464.62C233.016 464.62 218.6 450.205 218.6 432.371C218.6 414.505 233.016 400.09 250.85 400.09C268.715 400.09 283.131 414.505 283.131 432.371C283.131 450.205 268.715 464.62 250.85 464.62ZM347.63 378.59H154.101V77.5304H347.63V378.59Z",
    fill: "#f0fff1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.9a65689a0e3cec49d6666e81e2cfe812.svg";
export { ForwardRef as ReactComponent };